// DateUtils.js
// Utility for robust yyyy-MM-dd date comparison and ISO normalization

/**
 * Extracts only yyyy-MM-dd from any date string, stripping time and fractional seconds.
 * @param {string} str - Any date string
 * @returns {string} - yyyy-MM-dd or ''
 */
export function toYMD(str) {
  if (!str) return '';
  // Handles '2025-07-09T00:00:00.123Z', '2025-07-09 00:00:00', etc.
  return str.match(/^\d{4}-\d{2}-\d{2}/)?.[0] || '';
}


/**
 * Converts a 'yyyy-MM-dd' date string to ISO 8601 with time (UTC midnight).
 * If already in ISO format, returns as-is.
 * @param {string} dateStr
 * @returns {string} ISO 8601 string, e.g. '2025-07-09T00:00:00Z'
 */
export function toIsoDateTime(dateStr) {
  if (!dateStr) return '';
  // If already ISO with time, return as-is
  if (dateStr.includes('T')) return dateStr;
  // Add UTC midnight
  return `${dateStr}T00:00:00Z`;
}

/**
 * Parse a yyyy-MM-dd string to a Date object in UTC (avoids timezone issues).
 * @param {string} str - Date string in yyyy-MM-dd format
 * @returns {Date}
 */
export function parseYMD(str) {
  const [y, m, d] = str.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

/**
 * Returns -1 if a < b, 1 if a > b, 0 if equal
 * @param {string} a - yyyy-MM-dd
 * @param {string} b - yyyy-MM-dd
 */
export function compareYMD(a, b) {
  const da = parseYMD(a);
  const db = parseYMD(b);
  if (da < db) return -1;
  if (da > db) return 1;
  return 0;
}

/**
 * Ensures the older date is first in [fromDate, toDate]
 * @param {string} fromDate
 * @param {string} toDate
 * @returns {[string, string]} [older, newer]
 */
export function orderDates(fromDate, toDate) {
  return compareYMD(fromDate, toDate) <= 0 ? [fromDate, toDate] : [toDate, fromDate];
}
